var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.08 5.12H1.28C.573 5.12 0 5.693 0 6.4c0 .707.573 1.28 1.28 1.28h12.8c.707 0 1.28-.573 1.28-1.28 0-.707-.573-1.28-1.28-1.28zM14.08 0H1.28C.573 0 0 .573 0 1.28c0 .707.573 1.28 1.28 1.28h12.8c.707 0 1.28-.573 1.28-1.28 0-.707-.573-1.28-1.28-1.28zM6.4 10.24H1.28c-.707 0-1.28.573-1.28 1.28 0 .707.573 1.28 1.28 1.28H6.4c.707 0 1.28-.573 1.28-1.28 0-.707-.573-1.28-1.28-1.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.b049850e2c746a3ae771a1b09e286199.svg";
export { ForwardRef as ReactComponent };